import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import MoleculeCanvas from "@/components/MoleculeCanvas";

const EASE = [0.22, 1, 0.36, 1];

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 140]);
  const opacity = useTransform(scrollYProgress, [0, 0.75], [1, 0]);

  return (
    <section ref={ref} id="top" data-testid="hero-section" className="relative flex min-h-[68vh] items-center justify-center overflow-hidden sm:min-h-[74vh]">
      <div className="absolute inset-0">
        <MoleculeCanvas />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_45%,transparent_0%,#050505_80%)]" />
      </div>

      <motion.div style={{ y, opacity }} className="relative z-10 flex flex-col items-center px-6">
        <motion.img
          src="/logo-full.png"
          alt="AxenLabs"
          data-testid="hero-logo"
          initial={{ opacity: 0, y: 32, filter: "blur(12px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.6, delay: 0.4, ease: EASE }}
          className="w-56 sm:w-72 lg:w-80"
        />
      </motion.div>
    </section>
  );
}
